import type { GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts200 } from '@fukuri-admins/apis/client/gen/model';
import type { ClientContractTermDetailHeaderPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof ClientContractTermDetailHeaderPresentation>;

type Args = {
  /** API レスポンス（useFetch の data をそのまま受け取る） */
  data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientIdClientContracts200;
  /** 企業契約期間 ID（Screen 層でパース・検証済みの数値） */
  termId: number;
};

type IConvertToPresentationProps = (args: Args) => PresentationProps;

/**
 * 企業契約期間データを ClientContractTermDetailHeader の Presentation Props に変換する
 *
 * - data.client_contracts から termId に一致するレコードを絞り込む
 * - 見つからない場合は Error を throw する
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({ data, termId }) => {
  const contractTerm = data.client_contracts.find(c => c.id === termId);

  if (!contractTerm) {
    throw new Error(`企業契約期間 ID ${termId} が見つかりません`);
  }

  return {
    clientName: contractTerm.client.name,
  };
};
